import { useRouter } from 'next/router'
import { isNil } from 'ramda'

const isTheSameApp = (url: string) => {
  const basepath = window.BASEPATH

  if (isNil(basepath)) {
    return false
  }

  // relative path
  if (!url.startsWith('http')) {
    return url.startsWith(basepath)
  }

  // absolute path
  return url.startsWith(window.location.origin + basepath)
}

const REDIRECT_TIMEOUT = 100
/**
 * Recognize if the url is from the same app and redirect
 * with the NextJS router or window.location.href
 * @param url
 */

export const useRedirect = () => {
  const { push } = useRouter()

  const redirect = async (url: string) => {
    if (isTheSameApp(url)) {
      await push(url)
    } else {
      // Safari doesn't handle window.location.replace well without setTimeout.
      setTimeout(() => {
        window.location.replace(url)
      }, REDIRECT_TIMEOUT)
    }
  }

  return redirect
}
